<template>
  <button
    :type="type"
    :class="buttonClasses"
    :disabled="isDisabled || isLoading"
    @click="handleClick"
  >
    <spinner v-if="isLoading" size="small" />
    <span
      v-else-if="icon"
      class="material-symbols-outlined leading-none"
      :class="iconSizeClass"
    >{{ icon }}</span>
    <span v-if="$slots.default" class="button__content">
      <slot />
    </span>
  </button>
</template>

<script>
import Spinner from 'shared/components/Spinner.vue';

const VARIANT_CLASS_MAP = {
  outline: 'button-outline',
  filled: 'button-filled',
  naked: 'button-naked',
  ghost: 'button-ghost',
};

const SIZE_CLASS_MAP = {
  tiny: 'px-2 py-1 text-xs gap-1',
  small: 'px-3 py-1.5 text-sm gap-1',
  medium: 'px-3 py-2 text-base gap-1',
  large: 'px-5 py-2.5 text-base gap-2',
};

const ICON_SIZE_CLASS_MAP = {
  tiny: 'text-[12px]',
  small: 'text-[16px]',
  medium: 'text-[24px]',
  large: 'text-[30px]',
};

export default {
  name: 'WootButtonV2',
  components: { Spinner },
  props: {
    type: {
      type: String,
      default: 'button',
    },
    variant: {
      type: String,
      default: 'filled',
      validator: v => Object.keys(VARIANT_CLASS_MAP).includes(v),
    },
    size: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isExpanded: {
      type: Boolean,
      default: false,
    },
    classNames: {
      type: [String, Object],
      default: '',
    },
  },
  computed: {
    hasOnlyIcon() {
      return !this.$slots.default && (this.icon || this.isLoading);
    },
    iconSizeClass() {
      return ICON_SIZE_CLASS_MAP[this.size] || 'text-[16px]';
    },
    buttonClasses() {
      return [
        'inline-flex items-center justify-center transition-colors duration-150 outline-none focus:outline-none',
        VARIANT_CLASS_MAP[this.variant] || VARIANT_CLASS_MAP.filled,
        SIZE_CLASS_MAP[this.size] || 'px-4 py-2 text-sm gap-1.5',
        this.hasOnlyIcon ? '!px-2' : '',
        this.isExpanded ? 'w-full' : '',
        this.classNames,
      ];
    },
  },
  methods: {
    handleClick(evt) {
      this.$emit('click', evt);
    },
  },
};
</script>
